import { AccountOffIcon } from './AccountOffIcon';

/**
 * author: Simran
 * id 2306EFC9-3375-4D03-A631-A32BD72075EC
 * name account-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-off.svg
 * tags
 * - Account / User 
 */
export const PersonOffIcon = AccountOffIcon;
export default PersonOffIcon